import timeAgoFormat from './timeAgoFormat';

/**
 * Given a date, determine how long ago that date was set.
 * @param {string} dateString - The date string to format.
 *
 * @returns {string} - The formatted relative date time.
 */
export default function timeAgo(dateString) {
  // Bail if we don't have a date.
  if (! dateString) {
    return '';
  }

  // Fallback. Convert date. Assume this will always convert the date.
  const date = 'object' === typeof dateString
    ? dateString : new Date(dateString);

  // Today's date/time.
  const today = new Date();

  // Get difference between today and the time string.
  const diff = today - date;
  let diffTemp = diff / 1000;

  // Bail if we're in the future.
  if (0 > diff) {
    return '';
  }

  // Get time in seconds.
  // Ref: http://convert-units.info/time/second/31536000
  // Will not get seconds, as we'll be refreshing every 60 seconds/1 minute.
  const years = Math.floor(diffTemp / 31536000);
  const months = Math.floor((diffTemp %= 31536000) / 2592000);
  const days = Math.floor((diffTemp %= 31536000) / 86400);
  const hours = Math.floor((diffTemp %= 86400) / 3600);
  const minutes = Math.floor((diffTemp %= 3600) / 60);

  // If years.
  if (years) {
    return timeAgoFormat(years, 'year');
  }

  // If months.
  if (months) {
    return timeAgoFormat(months, 'month');
  }

  // If days.
  if (days) {
    return timeAgoFormat(days, 'day');
  }

  // If hours.
  if (hours) {
    return timeAgoFormat(hours, 'hour');
  }

  // If minutes.
  if (minutes) {
    return timeAgoFormat(minutes, 'minute');
  }

  // Default, assume just updated.
  return 'just now';
}
